import { Fragment, PureComponent, ReactNode } from 'react';
import { Table } from 'antd';
import { CalculatorConfigType, EkaInterpretation } from './calculatorsTypes';

type Interpretation = {
    columnsToInclude: { title: string; name: string }[];
    data: { [key: string]: string }[];
};

type Props = {
    ekaInterpretation?: EkaInterpretation;
};

const defaultScrollValues = { x: '100%', y: '100%' };
class CalculatorInterPretationTable extends PureComponent<Props> {
    renderValues = (interpretationValue: string) => {
        return (
            <Fragment>
                <div className="whitespace-nowrap px-4">{interpretationValue}</div>
            </Fragment>
        );
    };

    buildColumns = (interpretationData: Interpretation | undefined) => {
        if (!interpretationData) {
            return [];
        }

        const totalColumns = interpretationData.columnsToInclude.length;
        const columnsData = interpretationData.columnsToInclude;
        const columnsArray = [];

        for (let i = 0; i < totalColumns; i++) {
            columnsArray.push({
                dataIndex: columnsData[i].name,
                render: this.renderValues,
                width: 150,
            });
        }
        return columnsArray;
    };

    render(): ReactNode {
        const { ekaInterpretation } = this.props;
        if (!ekaInterpretation) {
            return null;
        }
        const columns = [...this.buildColumns(ekaInterpretation)];
        return (
            <Table
                bordered={false}
                showHeader={false}
                tableLayout={'auto'}
                className="border border-darwin-neutral-100 h-auto w-full overflow-hidden h-full interpretation-table"
                dataSource={ekaInterpretation?.data}
                pagination={false}
                sticky={true}
                scroll={defaultScrollValues}
                columns={columns}
            ></Table>
        );
    }
}

export default CalculatorInterPretationTable;
